import { render, staticRenderFns } from "./reportMedical.vue?vue&type=template&id=83ac1e06&scoped=true&"
import script from "./reportMedical.vue?vue&type=script&lang=js&"
export * from "./reportMedical.vue?vue&type=script&lang=js&"
import style0 from "./reportMedical.vue?vue&type=style&index=0&id=83ac1e06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ac1e06",
  null
  
)

export default component.exports